import types from './types'

const add = (data) => {
  return (dispatch) => {
    dispatch({ type: types.add, data })
  }
}

const remove = () => {
  return (dispatch) => {
    dispatch({ type: types.remove })
  }
}

const getByKey = (key) => (dispatch, oldState) => {
  return oldState()?.temporaryRecord?.[key]
}

export default {
  add,
  remove,
  getByKey
}